export const Colors = {
  primary: "#1a59cb",
};
